module.exports = __webpack_public_path__ + "img/详情页头图_新春年货节.34a9f971.png";